const waypointIndicatorSrc = require(`../assets/models/waypoint-indicator.glb`);
import { waitForDOMContentLoaded } from "../utils/async-utils";
import { loadModel } from "./gltf-model-plus";
import { cloneObject3D } from "../utils/three-utils";

let waypointIndicator;

waitForDOMContentLoaded().then(() => {
  loadModel(waypointIndicatorSrc).then(gltf => {
    waypointIndicator = gltf;
  });
});

AFRAME.registerComponent("waypoint-icon", {
  schema: {
    position: { type: "vec3", default: { x: 0, y: 1.6, z: 0 } },
    scale: { type: "vec3", default: { x: 1, y: 1, z: 1 } }
  },
  tick(t, dt) {
    if (waypointIndicator && !this.waypointIndicator) {
      this.waypointIndicator = cloneObject3D(waypointIndicator.scene);
      this.waypointIndicatorContainer.add(this.waypointIndicator);
      this.waypointIndicatorContainer.visible = false;

      this.waypointMixer = new THREE.AnimationMixer(this.waypointIndicator);
      this.waypointClip = this.waypointMixer.clipAction(this.waypointIndicator.animations[0]);
      this.waypointClip.play();
    }

    if (this.waypointMixer && this.waypointIndicatorContainer?.visible) {
      this.waypointMixer.update(dt / 1000);
    }
  },
  init() {
    // Create group
    const group = new THREE.Group();
    // Down 0.8 to center the icon on the ground
    group.position.set(0, -0.8, 0);

    // Load the waypoint indicator model
    this.waypointIndicatorContainer = new THREE.Object3D();

    this.waypointIndicatorContainer.name = "waypoint-icon";
    this.waypointIndicatorContainer.position.set(0, 0, 0);
    // this.waypointIndicatorContainer.visible = false;
    group.add(this.waypointIndicatorContainer);

    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshBasicMaterial({
      color: 0x000000,
      transparent: true,
      opacity: 0,
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: false,
      alphaTest: 1
    });

    const mesh = new THREE.Mesh(geometry, material);

    mesh.position.set(this.data.position.x, this.data.position.y, this.data.position.z);
    mesh.scale.set(this.data.scale.x, this.data.scale.y, this.data.scale.z);

    group.add(mesh);

    this.el.setObject3D("group", group);
  },
  remove() {
    this.waypointMixer.stopAllAction();
    this.el.removeObject3D("group");
  }
});
